<div class="etiqueraDesarrollo" *ngIf="!envi" [ngClass]="{'on': apiON ,'off': !apiON && !this.updating, 'update': this.updating}" >
  {{this.texto}}
    <div class="iconosIzquierda enLinea"  id="API">
    <i class="fas fa-circle icon"></i>
  </div>
</div>
<router-outlet (activate)="scrollTop($event)"></router-outlet>

